import type { ReactNode } from "react";

import Tooltip from "../../../components/Tooltip/Tooltip";

interface HintIconProps {
  hintText: string;
  iconClassName?: string;
  tooltipClassName?: string;
}

export function HintIcon({
  hintText,
  iconClassName = "",
  tooltipClassName = "",
}: HintIconProps) {
  return (
    <Tooltip text={hintText} className={tooltipClassName}>
      <span
        className={`w-[0.9rem] h-[0.9rem] text-xs-x text-center font-semibold rounded-full cursor-pointer flex justify-center items-center ${iconClassName}`}
      >
        i
      </span>
    </Tooltip>
  );
}

interface LabeledFieldProps {
  label: string;
  children: ReactNode;
  hintText?: string;
  className?: string;
  labelClassName?: string;
  tooltipClassName?: string;
  iconClassName?: string;
}

function LabeledField({
  label,
  children,
  hintText = "",
  className = "",
  labelClassName = "",
  tooltipClassName = "",
  iconClassName = "",
}: LabeledFieldProps) {
  return (
    <div id="labeled-field" className={`relative p-[0.3125rem] ${className}`}>
      <div
        className={`italic font-light text-sm leading-tight mb-1 ${labelClassName}`}
      >
        {label}{" "}
        {hintText && (
          <HintIcon
            hintText={hintText}
            tooltipClassName={tooltipClassName}
            iconClassName={iconClassName}
          />
        )}
      </div>
      <p className="font-semibold">{children}</p>
    </div>
  );
}

export default LabeledField;
